import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const FinishOauthSignupModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "FinishOauthSignupModalContainer" */
      './FinishOauthSignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
